import type { FallbackProps } from '@gik/core/api/BaseAPIConfig';
import { ISRRevalidateTimeout, baseFallback } from '@gik/core/api/BaseAPIConfig';
import { withTitle } from '@gik/core/hocs/withTitle';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import { HowItWorksPage } from '@gik/marketing/pages/HowItWorksPage';
import type { HowItWorksPageServerProps } from '@gik/marketing/pages/HowItWorksPage/HowItWorksPage';
import { getTaxonomiesBuildResponse } from '@/api/give/taxonomies';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import { SWRConfig } from 'swr';

export default function HowItWorksPageComp({ fallback }: FallbackProps<HowItWorksPageServerProps>) {
  return withTitle(
    'How it Works',
    <SWRConfig value={{ fallback }}>
      <HowItWorksPage />
    </SWRConfig>
  );
}

HowItWorksPageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};

async function _getStaticProps() {
  const situations = getTaxonomiesBuildResponse('situation', {
    page: 1,
    perPage: 5,
  });

  return baseFallback(
    {
      [situations.key]: await situations.json,
    },
    undefined,
    ISRRevalidateTimeout.sitemapSlow
  );
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));
